import React, { useEffect, useState } from "react";
import "./operation.css";
import SearchFilter from "../../../operations/components/AdvanceFilter/AdvanceFilter";
import TabulationComponent from "../Tabulation/Tabulation";
import Card from "../Cards/Card";
import statsData from "../../Helper/call-stats-data.json";
// import Header from "../HeaderOpsPage/Header";
import { CallStatsDashboard } from "../../components/StatusDash/StatusDash";
import {
  getOperationDataInit,
  setActiveSearch,
  setActiveTab,
  setSelectedCard,
  setSeverityFilter,
  setStartDate,
  setEndDate,
} from "../../../redux/slices/operationHomeSlice";
import { useDispatch, useSelector } from "react-redux";
import { FiUsers } from "react-icons/fi";
import ManageUsersModal from "../../../operations/components/ManageUsers/ManageUsersModal";
const OperationsHome = ({ onSearch }) => {
  const activeSearch = useSelector((state) => state.operationHome.activeSearch);
  const [searchTerm, setSearchTerm] = useState("");
  const [showManageUsers, setShowManageUsers] = useState(false);
  const stats = JSON.parse(JSON.stringify(statsData));
  const dispatch = useDispatch();

  useEffect(() => {
    if (activeSearch === "advance") return;
    setSearchTerm("");
  }, [activeSearch]);

  const handleSearch = (data) => {
    console.log("[OperationsHome] handleSearch → searchTerm:", searchTerm, "| client/severity:", data);
    onSearch({ searchTerm, ...data });
    console.log("[OperationsHome] dispatch setActiveSearch → payload: 'advance' (mode flag, not the severity value)");
    dispatch(setActiveSearch("advance"));
    // setSearchTerm("");
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };
  const handleTabClick = (tab) => {
    dispatch(setActiveTab(tab.name));
    dispatch(setActiveSearch(null));
    dispatch(setSelectedCard(null));
    if (tab.name === "range") {
      if (tab.startDate) dispatch(setStartDate(tab.startDate));
      if (tab.endDate) dispatch(setEndDate(tab.endDate));
      if (!(tab.startDate && tab.endDate)) return;
    } else {
      dispatch(setStartDate(null));
      dispatch(setEndDate(null));
    }
    dispatch(getOperationDataInit(tab));
  };
  return (
    <div className="operations-home">
      <div className="operations-toolbar">
        <TabulationComponent handleTabClick={handleTabClick} />
        <button
          type="button"
          className="mu-trigger-btn"
          onClick={() => setShowManageUsers(true)}
          aria-haspopup="dialog"
          aria-label="Manage teams"
        >
          <FiUsers aria-hidden="true" />
          <span>Manage Teams</span>
        </button>
      </div>

      <ManageUsersModal
        isOpen={showManageUsers}
        onClose={() => setShowManageUsers(false)}
      />

      <div className="filter-section">
        <SearchFilter
          searchTerm={searchTerm}
          onSearchChange={handleSearchChange}
          onSearch={handleSearch}
        />

        <CallStatsDashboard />
      </div>
    </div>
  );
};

export default OperationsHome;
